// 新增跳转组 / 新增域名弹框(从 route 抽出)。
import { useState, type FormEvent } from 'react'
import { Button } from '@dogdisk/shared'
import type { CreateChainInput, CreateDomainInput } from '../../_lib/jumpdomain-api'

export function AddChainDialog({
  onClose,
  onSubmit,
}: {
  onClose: () => void
  onSubmit: (input: CreateChainInput) => Promise<void>
}) {
  const [name, setName] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setErr(null)
    try {
      await onSubmit({ name })
    } catch (e2) {
      setErr(e2 instanceof Error ? e2.message : 'submit failed')
    } finally {
      setBusy(false)
    }
  }
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      data-testid="Ye71I-add-chain-dialog"
    >
      <form className="w-full max-w-md rounded bg-white p-6" onSubmit={submit}>
        <h3 className="mb-4 text-lg font-semibold">新增跳转组</h3>
        <label className="mb-3 block">
          <span className="text-sm">组名(1-50 字)</span>
          <input
            className="mt-1 w-full rounded border p-2"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            data-testid="Ye71I-chain-name"
          />
        </label>
        <p className="mb-3 text-xs text-gray-400">新组默认落地方式为「本站代理」,创建后可在组内切换。</p>
        {err && <p className="mb-3 text-xs text-red-600">{err}</p>}
        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onClose}>
            取消
          </Button>
          <Button type="submit" disabled={busy} data-testid="Ye71I-chain-submit">
            {busy ? '…' : '保存'}
          </Button>
        </div>
      </form>
    </div>
  )
}

export function AddDomainDialog({
  chainId,
  level,
  onClose,
  onSubmit,
}: {
  chainId: string
  level: 1 | 2 | 3
  onClose: () => void
  onSubmit: (input: CreateDomainInput) => Promise<void>
}) {
  const [domain, setDomain] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState<string | null>(null)
  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setErr(null)
    try {
      await onSubmit({ chain_id: chainId, level, domain })
    } catch (e2) {
      setErr(e2 instanceof Error ? e2.message : 'submit failed')
    } finally {
      setBusy(false)
    }
  }
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      data-testid="Ye71I-add-domain-dialog"
    >
      <form className="w-full max-w-md rounded bg-white p-6" onSubmit={submit}>
        <h3 className="mb-4 text-lg font-semibold">添加 L{level} 域名</h3>
        <label className="mb-3 block">
          <span className="text-sm">域名</span>
          <input
            className="mt-1 w-full rounded border p-2 font-mono"
            required
            type="text"
            placeholder="sub.example.com"
            value={domain}
            onChange={(e) => setDomain(e.target.value)}
            data-testid="Ye71I-add-domain-input"
          />
        </label>
        {err && <p className="mb-3 text-xs text-red-600">{err}</p>}
        <div className="flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onClose}>
            取消
          </Button>
          <Button type="submit" disabled={busy} data-testid="Ye71I-add-domain-submit">
            {busy ? '…' : '保存'}
          </Button>
        </div>
      </form>
    </div>
  )
}
